import React from 'react';
import { Box, DataTable } from '../../../../common/components';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { InternalButtonBar } from '../../../layout/components';
import ReallocateCommissionModal from '../../../account/components/RellocateCommissionModal/ReallocateCommissionModal';
import getIncludedResource from '../../../../helpers/getIncludedResource';
import formatDate from '../../../../helpers/formatDate';
import { refreshData } from '../../../../common/components/DataTable/redux/dataTableActions';
import { getPolicy } from '../../redux/policyActions';
import { connect } from 'react-redux';

const PolicyAccounts = ({ dispatch, reference, resource }) => {
  const handleReallocateCommissionClose = () => {
    dispatch(refreshData('accounts'));
    dispatch(getPolicy(resource.data.id, false));
  };

  const premiums = getIncludedResource(resource.data, resource.included, 'premiums');
  const broker = getIncludedResource(resource.data, resource.included, 'broker');
  const brokerOrganisationId = broker.data.relationships
    ? broker.data.relationships.organisation.data.id
    : undefined;

  return (
    <div>
      <Box>
        <h2 className="resource-name">{reference}</h2>

        <DataTable
          source={'/accounts/ledger-entries'}
          autoFilters={[
            { type: 'filter[policy]', value: resource.data.id },
            { type: 'page[limit]', value: 100 },
          ]}
          name="accounts"
          showTotal
        >
          <TableHeaderColumn dataField="id" isKey hidden />

          <TableHeaderColumn
            dataField="created_at"
            dataSort
            width={'100px'}
            dataFormat={formatDate}
          >
            Transacted at
          </TableHeaderColumn>

          <TableHeaderColumn dataField="account_name" width={'175px'}>
            Account
          </TableHeaderColumn>

          <TableHeaderColumn dataField="description" width={'300px'} dataSort>
            Description
          </TableHeaderColumn>

          <TableHeaderColumn
            dataField="formatted_amount"
            width={'100px'}
            dataAlign="right"
          >
            Amount
          </TableHeaderColumn>
        </DataTable>
        {broker && (
          <InternalButtonBar
            buttons={[
              {
                permission: [],
                button: (
                  <ReallocateCommissionModal
                    key="commission-modal"
                    premiums={premiums}
                    brokerOrganisationId={brokerOrganisationId}
                    handleReallocateCommissionClose={handleReallocateCommissionClose}
                  />
                ),
              },
            ]}
          />
        )}
      </Box>
    </div>
  );
};

export default connect()(PolicyAccounts);
